<!-- <div class="home-btn d-none d-sm-block">
  <a href="/" class="text-dark"><i class="fas fa-home h2"></i></a>
</div> -->
<div class="account-pages my-5 pt-sm-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-10 col-xl-10">
                <div class="card overflow-hidden">
                    <div class="bg-soft-primary">
                        <div class="row">
                            <div class="col-7">
                                <div class="text-primary p-4">
                                    <h5 class="text-primary">Registrate</h5>
                                    <p>Obten el mejor sistema de facturación electrónica</p>
                                </div>
                            </div>
                            <div class="col-5 align-self-end">
                                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0">
                        <div>
                            <a href="/">
                                <div class="avatar-md profile-user-wid mb-4">
                                    <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo.svg" alt="" class="rounded-circle" height="34">
                  </span>
                                </div>
                            </a>
                        </div>
                        <div class="p-2">
                            <form class="form-horizontal">
                                <div class="form-group">
                                    <label for="username">RUC</label>
                                    <input type="text" name="ruc" [(ngModel)]="registro.ruc" class="form-control" id="ruc" placeholder="Ingresar Ruc">
                                </div>
                                <div class="form-group">
                                    <label for="pwd">Razón social</label>
                                    <input type="text" name="razonSocial" [(ngModel)]="registro.razonSocial" class="form-control" id="razonSocial" placeholder="Ingrese Razón Social">
                                </div>
                                <div class="form-group">
                                  <label for="pwd">Dirección</label>
                                  <input type="text" name="direccion" [(ngModel)]="registro.direccion" class="form-control" id="razonSocial" placeholder="Ingrese Dirección">
                              </div>
                                <div class="form-group">
                                    <label for="useremail">Correo Eléctronica</label>
                                    <input type="email" name="mail" [(ngModel)]="registro.mail" class="form-control" id="mail" placeholder="Ingrese Correo">
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="card-title">Certificado digital</div>

                                                <p class="card-title-desc">Enviar archivo .p12 otorgado por el ente proveedor de certificados electronicos con respectiva clave y fecha de caducidad .
                                                </p>

                                                <div class="horizontal-container" fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="stretch" fxFlex="auto">

                                                    <!-- <div class="content-container" fxLayout="column" fxLayoutAlign="stretch" fxFlex="auto">
                                                      <dropzone *ngIf="type === 'component'" class="dropzone-container" [config]="config" [disabled]="disabled" fxLayout="row" fxLayoutAlign="start strech" fxFlex="auto" [message]="'Click or drag images here to upload'" (init)="onUploadInit($event)" (error)="onUploadError($event)"
                                                          (success)="onUploadSuccess($event)"></dropzone>

                                                      <div *ngIf="type === 'directive'" class="dropzone dropzone-container" [dropzone]="config" [disabled]="disabled" (init)="onUploadInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)"></div>
                                                  </div> -->
                                                    <div>

                                                      <div class="content-container flex flex-col content-stretch">
                                                        <dropzone (removedfile)="onRemove($event)"   *ngIf="type === 'component'" class="dropzone-container flex" [config]="config" [message]="'Click or drag images here to upload'" (init)="onUploadInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">

                                                        </dropzone>

                                                        <div *ngIf="type === 'directive'" class="dropzone dropzone-container justify-center flex flex-1" [dropzone]="config" (init)="onUploadInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)"></div>
                                                      </div>

                                                        <form>
                                                            <!-- <dropzone class="dropzone" [message]="'Click or arrastre el certificado'" (success)="onUploadSuccess($event)" [config]="config">

                                                            </dropzone> -->
                                                        </form>
                                                        <div class="previews dropzone-previews"></div>
                                                    </div>
                                                    <div class="row">

                                                        <div class="col-4">
                                                            <label class="control-label">Contraseña</label>
                                                            <input id="clave" [(ngModel)]="registro.clave" name="clave" class="form-control" type="text">
                                                        </div>



                                                        <div class="col-4">
                                                            <label>Fecha caducidad :</label>
                                                            <div class="input-group clockpicker">
                                                                <input ngbDatepicker class="form-control" [(ngModel)]="toDate" [ngModelOptions]="{standalone: true}" placeholder="yyyy-mm-dd" #d2="ngbDatepicker">
                                                                <div class="input-group-append" (click)="d2.toggle()">
                                                                    <span class="input-group-text"><i class="mdi mdi-calendar"></i></span>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="col-4 align-self-end">
                                                            <button type="button" (click)="guardar()" class="btn btn-primary">Subir Certificado</button>
                                                        </div> -->
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div class="mt-4">
                                    <button class="btn btn-primary btn-block" (click)="registrar()" type="submit">Registrame</button>
                                </div>

                                <!--
                                <div class="mt-4 text-center">
                                    <p class="mb-0">By registering you agree to the Skote <a href="javascript: void(0);" class="text-primary">Terms of
                      Use</a></p>
                                </div> -->
                            </form>
                        </div>

                    </div>
                </div>
                <div class="mt-5 text-center">
                    <p>Ya cuentas con el servicio ? <a routerLink="/account/login" class="font-weight-medium text-primary"> Ingreso</a>
                    </p>
                    <p>© {{year}} ElecDocs. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p>
                </div>
            </div>
        </div>
    </div>
</div>
